/// <reference path="../app.js"/>

class HiddenEmailController {
	static init() {
		$("[data-hidden-email]").on("click", function() {
			const self = $(this);

			$("#" + self.data("open")).text(self.data("hidden-email").split("").map(char => String.fromCharCode(char.charCodeAt(0) - 2)).join(""));
		});
	}
}